/**
 * Time-based constants for session banner behavior
 */
export const TIME_CONSTANTS: {
	// Duration milestones
	readonly TWO_HOURS_MS: number;
	readonly ONE_HOUR_MS: number;
	readonly THIRTY_MINUTES_MS: number;
	readonly FIFTEEN_MINUTES_MS: number;
	readonly TEN_MINUTES_MS: number;
	readonly ONE_MINUTE_MS: number;
	readonly MILESTONE_GRACE_PERIOD_MS: number;
	readonly UPDATE_INTERVAL_MS: 10000;
	/** Re-authentication detection threshold - session timestamp going backward by this amount indicates new session */
	readonly REAUTH_DETECTION_THRESHOLD_MS: number; // 1 minute
	// Time unit conversions
	readonly SECONDS_PER_MINUTE: 60;
	readonly MINUTES_PER_HOUR: 60;
	// Display formatting constants
	readonly DISPLAY_ADJUSTMENT_MINUTES: 1;
} = {
	// Duration milestones
	TWO_HOURS_MS: 2 * 60 * 60 * 1000,
	ONE_HOUR_MS: 60 * 60 * 1000,
	THIRTY_MINUTES_MS: 30 * 60 * 1000,
	FIFTEEN_MINUTES_MS: 15 * 60 * 1000,
	TEN_MINUTES_MS: 10 * 60 * 1000,
	ONE_MINUTE_MS: 60 * 1000,
	MILESTONE_GRACE_PERIOD_MS: 5 * 60 * 1000,
	UPDATE_INTERVAL_MS: 10000,
	/** Re-authentication detection threshold - session timestamp going backward by this amount indicates new session */
	REAUTH_DETECTION_THRESHOLD_MS: 1 * 60 * 1000, // 1 minute

	// Time unit conversions
	SECONDS_PER_MINUTE: 60,
	MINUTES_PER_HOUR: 60,

	// Display formatting constants
	DISPLAY_ADJUSTMENT_MINUTES: 1, // Add 1 minute for display to account for current partial minute
} as const;
